/**
 * /fields/* route parsing utility (G.23).
 *
 * URL schema:
 *   /fields                     → fields list
 *   /fields/{uuid}              → field detail, default tab
 *   /fields/{uuid}/{tab-slug}   → field detail, specific tab
 */

import { resolveTabSlug } from '../config/fieldTabSlugs';

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Parse a pathname into a field route descriptor.
 */
export function parseFieldRoute(pathname) {
  if (!pathname || typeof pathname !== 'string') {
    return { isFieldRoute: false };
  }
  // Must start with /fields but not /fieldssomething
  if (!pathname.startsWith('/fields') || (pathname.length > 7 && pathname[7] !== '/')) {
    return { isFieldRoute: false };
  }
  const cleaned = pathname.replace(/\/+$/, '');
  if (cleaned === '/fields') {
    return { isFieldRoute: true, listOnly: true };
  }
  const parts = cleaned.split('/').filter(Boolean); // ['fields', id, tab?]
  const fieldId = parts[1];
  const tabSlug = parts[2];

  return {
    isFieldRoute: true,
    listOnly: false,
    fieldId,
    tab: resolveTabSlug(tabSlug),
    invalidId: !UUID_RE.test(fieldId),
  };
}

/**
 * Build a field route URL from components.
 */
export function buildFieldRoute(fieldId, tab) {
  if (!fieldId) return '/fields';
  const resolved = resolveTabSlug(tab);
  return `/fields/${fieldId}/${resolved}`;
}
